import { BaseInvitePeopleAnalytics } from '../../analytics';
import { AnalyticsAction, AnalyticsActionSubject } from '../../types';

export class NoInvitePermissionAnalytics extends BaseInvitePeopleAnalytics {
	viewedNoInvitePermissionScreen(): void {
		const { disableNoInviteError, inviteFromAssignModalCohort, orgId, source, userRole } =
			this.commonAttributes;
		this.fireScreen({
			name: AnalyticsActionSubject.NO_INVITE_PERMOISSION_SCREEN,
			attributes: {
				disableNoInviteError,
				inviteFromAssignModalCohort,
				orgId,
				source,
				userRole,
			},
		});
	}

	getLinkedOrgSent(attributes?: { [key: string]: any }): void {
		const { source, userRole } = this.commonAttributes;
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.FETCH_LINKED_ORG,
			action: AnalyticsAction.SENT,
			attributes: {
				source,
				userRole,
				...attributes,
			},
		});
	}

	getOpenInviteNoteSent(attributes?: { [key: string]: any }): void {
		const { source, userRole } = this.commonAttributes;
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.FETCH_OPEN_INVITE_NOTE,
			action: AnalyticsAction.SENT,
			attributes: {
				source,
				userRole,
				...attributes,
			},
		});
	}
}
